import React from "react";
import {
  FaWallet,
  FaCoins,
  FaClock,
  FaTimesCircle,
  FaExclamationCircle,
  FaBalanceScale,
} from "react-icons/fa";
import LibraAmount from "../../../components/LibraAmount";

const StatCard = ({ icon, title, value }) => (
  <div className="p-4 bg-white shadow rounded-lg items-center">
    <h3 className="text-lg sm:text-xl font-semibold text-gray-600 flex items-center">
      <div className="mr-2 text-xl text-gray-600">{icon}</div>
      {title}
    </h3>
    <p className="text-xl sm:text-2xl font-bold text-gray-800 text-left">
      {value}
    </p>
  </div>
);

const PaymentStats = ({ data }) => {
  return (
    <div className="mb-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      <StatCard icon={<FaClock />} title="Epoch" value={data?.current_epoch} />
      <StatCard
        icon={<FaWallet />}
        title="Community Wallets"
        value={data?.cws ? data.cws.length : 0}
      />
      <StatCard
        icon={<FaCoins />}
        title="Total Paid"
        value={data && <LibraAmount amount={data.total_paid} />}
      />
      <StatCard
        icon={<FaExclamationCircle />}
        title="Total Pending"
        value={data && <LibraAmount amount={data.total_pending} />}
      />
      <StatCard
        icon={<FaTimesCircle />}
        title="Total Vetoed"
        value={data && <LibraAmount amount={data.total_veto} />}
      />
      <StatCard
        icon={<FaBalanceScale />}
        title="Total Balance"
        value={
          data && <LibraAmount amount={data.total_balance} scale={false} />
        }
      />
    </div>
  );
};

export default PaymentStats;
